<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
    name: "App",
}
</script>

<style>

  html, body, #app{
    height: 100%;
    width: 100%;
  }

  :-moz-placeholder { /* Mozilla Firefox 4 to 18 */
    color: #CCC; opacity:1;
  }

  ::-moz-placeholder { /* Mozilla Firefox 19+ */
    color: #CCC;opacity:1;
  }

  input:-ms-input-placeholder{
    color: #CCC;opacity:1;
  }

  input::-webkit-input-placeholder{
    color: #CCC;opacity:1;
  }
  body{
    background: #F2F2F2;
  }

  ul,li{
    list-style: none;
  }

  *::-webkit-scrollbar {/*滚动条整体样式*/
    width: 5px;     /*高宽分别对应横竖滚动条的尺寸*/
    height: 5px;
  }
  *::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
    -webkit-box-shadow: inset 0 0 4px rgba(0,0,0,0.2);
    border-radius: 5px;
    background: #ddd;
  }

  .el-input__inner, .el-input-group__append, .el-input-group__prepend,.el-button--medium {
    border-radius: 0 !important;
  }

  .el-step__head.is-process,.el-step__title.is-process {
    color: #5a8ceb;
  }

  .el-step__title.is-success {
    color: #c0c4cc;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue